import ReactModal from 'react-modal';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import styles from './slider-modal.css';
import {Map} from 'immutable';

import {
    closeSliderModal
} from '../../reducers/modals';

class SliderModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleSubmit',
            'handleChangeMin',
            'handleChangeMax',
            'formatMin',
            'formatMax'
        ]);
        const { monitorId, monitors } = props;
        const monitor = monitors.get(monitorId) || {};
        const min = monitor.sliderMin || 0;
        const max = monitor.sliderMax === 0 ? 0 : (monitor.sliderMax || 100);
        this.state = {
          min,
          max
        };
    }
    componentWillUnmount () {
    }
    handleSubmit () {
      // this.props.onSubmit();
      if (+this.state.min >= +this.state.max) {
        return;
      }
      if (Number.isNaN(+this.state.min) || Number.isNaN(+this.state.max)) {
        return;
      }
      this.props.onClose();
      this.props.vm.runtime.requestUpdateMonitor(Map({
          id: this.props.monitorId,
          sliderMin: +this.state.min,
          sliderMax: +this.state.max
      }));
    }
    handleCancel () {
        this.props.onClose();
    }
    handleChangeMin(event) {
      const value = event.target.value
      this.setState({
        min: value
      });
    }
    handleChangeMax(event) {
      const value = event.target.value
      this.setState({
        max: value
      });
    }
    formatMin(event) {
      const value = this.format(event.target.value)
      this.setState({
        min: value
      });
    }
    formatMax(event) {
      const value = this.format(event.target.value)
      this.setState({
        max: value
      });
    }
    format(value) {
      if (value[0] === '-') {
        return -value.replace(/[^\d]/g, '');
      }
      return +value.replace(/[^\d]/g, '');
    }
    render () {
        return (
            <ReactModal
              isOpen
              className={classNames(styles.modalContent, styles.sliderModalContent)}
              contentLabel="修改滑块范围"
              overlayClassName={styles.modalOverlay}
              onRequestClose={this.handleCancel}
          >
            <div className={styles.formGroup}>
              <span className={styles.formLabel}>最小值(整数)：</span>
              <input className={styles.input} type="text" value={this.state.min} onBlur={this.formatMin} onChange={this.handleChangeMin} />
            </div>
            <div className={styles.formGroup}>
              <span className={styles.formLabel}>最大值(整数)：</span>
              <input className={styles.input} type="text" value={this.state.max} onBlur={this.formatMax} onChange={this.handleChangeMax} />
            </div>
            {Number.isNaN(+this.state.min) || Number.isNaN(+this.state.max) ? <div className={styles.formGroup}>请输入数字</div> : null}
            {+this.state.min >= +this.state.max ? <div className={styles.formGroup} style={{color: 'red', fontSize: '12px'}}>最小值必须小于最大值</div> : null}
            <div className={styles.formGroup}>
              <button className={styles.button} onClick={this.handleCancel} style={{marginRight: '20px'}}>取消</button>
              <button className={classNames(styles.button, styles.buttonPrimary)} onClick={this.handleSubmit}>确定</button>
            </div>
          </ReactModal>
        );
    }
}

SliderModal.propTypes = {
    onClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
  monitorId: state.scratchGui.currentMonitor.monitorId,
  monitors: state.scratchGui.monitors,
  vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeSliderModal());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SliderModal);
